import { productService } from '@/services/product'

const state = {
  products: [],
}



const actions = {
  getProducts({ commit, dispatch }, payload) {
    productService.getProducts()
      .then(
        products => {
          commit('setProducts', products)
        },
        error => {
          console.error(error)
          dispatch('alert/error', error.toString(), { root: true })
        }
      )
  },
  createProduct({ commit }, productData) {
    productService.createProduct(productData)
      .then(product => {
        console.log('created product', product)
        commit('pushProduct', product)
      })
      .catch(err => {
        console.error(err)
      })
  },
  editProduct({ dispatch, commit }, productData) {
    productService.editProduct(productData)
      .then(result => {
        // console.log(`edit product result: `, result)
        dispatch('getProducts')
      })
      .catch(err => {
        console.error(err)
      })
  },
  deleteProduct({ commit }, productId) {
    productService.deleteProduct(productId)
      .then((result) => {
        console.log(`deleted product result`, result)
        commit('spliceProduct', productId)
      })
      .catch(err => console.error(err))
  }
}
const mutations = {
  setProducts(state, products) {
    state.products = products
  },
  pushProduct(state, product) {
    state.products.push(product)
  },
  spliceProduct(state, productId) {
    let rmIndex = state.products.findIndex(p => p.productId == productId)
    if (rmIndex == -1) return console.error(`splicProduct no product with id ${productId}`)
    state.products.splice(rmIndex, 1)
  }
}

const getters = {
  getProductById: (state) => (id) => {
    return state.product.find(product => product.productId == id)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}